// WHAT: Personal Information Page Component
// WHY:  Simple page wrapper that renders PersonalSettingsView
// DOMAIN: Settings
// DEPENDENCIES: PersonalSettingsView component
// RISKS:
//   - NOTE: This is a thin wrapper with no additional logic

import React from "react";

import { PersonalSettingsView } from "@/domains/settings/screen/PersonalSettingsView";

/**
 * WHAT:
 *   Page component that renders the Personal Settings view.
 *
 * WHY:
 *   Provides routing entry point for personal information settings.
 *
 * BEHAVIOR:
 *   - Simply renders PersonalSettingsView component
 *   - No additional logic or state management
 *
 * RISKS:
 *   - NOTE: This is a thin wrapper - consider removing if not needed for routing
 *
 * @returns {JSX.Element} Personal information page component
 *
 */
export const PersonalInformationPage: React.FC = () => {
  return <PersonalSettingsView />;
};
